export const BooleanIcon = ({ value }) => {
  if (typeof value !== 'boolean') {
    return <span>-</span>;
  }

  if (value) {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="10" cy="10" r="10" fill="#22c55e" />
        <path
          d="M5.5 10.25 8.5 13.25 14.5 6.75"
          stroke="#ffffff"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="10" cy="10" r="10" fill="#e5e7eb" />
      <path
        d="M6 6 14 14M14 6 6 14"
        stroke="#6b7280"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

